import first from "lodash/first";
import { createSelector } from "reselect";

import type { RootState } from "../RootState";

import type { AnalyticsState } from "./AnalyticsState";

export const selectAnalyticsState = (state: RootState): AnalyticsState => state.analytics;

export const selectConfig = createSelector([selectAnalyticsState], (state) => state.config);

export const selectActiveTab = createSelector([selectAnalyticsState], (state) => state.activeTab);
export const selectIsLoading = createSelector([selectAnalyticsState], (state) => state.isLoading);

export const selectHistory = createSelector([selectAnalyticsState], (state) => state.history);

export const selectLastQuery = createSelector([selectHistory], (history) => first(history));

export const selectCurrentQuery = createSelector([selectAnalyticsState], (state) => state.query);
